import { lazy } from "react";

export const routesMap = {
  "/": { it: "/", en: "/en" },
  "/about": { it: "/chi-siamo", en: "/en/about" },
  "/contacts": { it: "/contatti", en: "/en/contacts" },
  "/privacy": { it: "/privacy", en: "/en/privacy" },
  "/gift-card": { it: "/gift-card", en: "/en/gift-card" },
  "/events": { it: "/eventi", en: "/en/events" },
  "/aperitivo-menu": { it: "/menu-aperitivo", en: "/en/aperitivo-menu" },
  "/menu-carta": { it: "/menu-alla-carta", en: "/en/menu-carta" },
  "/wine-list": { it: "/lista-vini", en: "/en/wine-list" },
  "/reviews": { it: "/recensioni", en: "/en/reviews" },
  "/404": { it: "/404", en: "/en/404" },
};

// Shared components first to avoid double imports
export const sharedComponents = {
  ContactForm: lazy(() => import("./components/Form")),
  Footer: lazy(() => import("./components/Footer")),
};

export const lazyRoutes = {
  Home: lazy(() => import("./pages/Home")),
  AboutUs: lazy(() => import("./pages/AboutUs")),
  Events: lazy(() => import("./pages/Events")),
  Reviews: lazy(() => import("./pages/Reviews")),
  AperitivoMenu: lazy(() => import("./pages/AperitivoMenu")),
  MenuCarta: lazy(() => import("./pages/MenuCarta")),
  WineList: lazy(() => import("./pages/WineList")),
  GiftCard: lazy(() => import("./pages/GiftCard")),
  PrivacyPolicy: lazy(() => import("./pages/Privacy")),
  NotFound: lazy(() => import("./pages/NotFound")),
};

export const getLocalizedRoute = (path, language) => {
  return routesMap[path]?.[language] || path;
};
